import { useEffect, useState, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { YF_ERROR } from '@/page/constants'
import { getPageType } from '@/page/store/selectors'

const useIsScrollable = (ref) => {
  const [scrollable, setScrollable] = useState(false)
  const pageType = useSelector(getPageType)

  const checkCMSScroll = useCallback(() => {
    const scrollHeight = (ref ? ref.current : document.documentElement).scrollHeight
    setScrollable(scrollHeight > window.innerHeight)
  }, [ref])

  const checkErrorScroll = useCallback(() => {
    const container = document.querySelector('.yf.hydra')
    setScrollable(container.scrollHeight > container.clientHeight)
  }, [])

  const contentScrollCheck = useMemo(() => {
    switch (pageType) {
      case YF_ERROR:
        return checkErrorScroll
      default:
        return checkCMSScroll
    }
  }, [checkErrorScroll, checkCMSScroll, pageType])

  useEffect(() => {
    /* const contentScrollCheck = () => {
      const scrollHeight = (ref ? ref.current : document.documentElement).scrollHeight
      setScrollable(scrollHeight > window.innerHeight)
    } */
    window.addEventListener('load', contentScrollCheck)
    window.addEventListener('resize', contentScrollCheck)
    return () => {
      window.removeEventListener('resize', contentScrollCheck)
      window.removeEventListener('load', contentScrollCheck)
    }
  })

  return scrollable
}

export default useIsScrollable
